import { match } from "ts-pattern";

import { WebsiteModal } from "shared/WebsiteModal";
import { NotifyContent } from "shared/product/ProductSection/ProductSpecifications/shared/ProductReminderModal/NotifyContent";
import { ValidatedContent } from "shared/product/ProductSection/ProductSpecifications/shared/ProductReminderModal/ValidatedContent";
import { ModalState } from "utils/useModalState";
import { useStepper } from "utils/useStepper";

enum StateStep {
  Notify,
  Validated,
}

type ProductReminderModalExtraProps = {
  isComingSoon?: boolean;
  productName?: string | null;
  subscriptionId: number;
};
type ProductReminderModalProps = Pick<ModalState, "isOpen" | "closeModal"> &
  ProductReminderModalExtraProps;

export const ProductReminderModal = ({
  closeModal,
  isOpen,
  isComingSoon = false,
  productName,
  subscriptionId,
}: ProductReminderModalProps) => {
  const { currentStep, goToNextStep } = useStepper([
    StateStep.Notify,
    StateStep.Validated,
  ]);

  return (
    <WebsiteModal isOpen={isOpen} onRequestClose={closeModal}>
      {match(currentStep)
        .with(StateStep.Notify, () => (
          <NotifyContent
            productName={productName}
            isComingSoon={isComingSoon}
            subscriptionId={subscriptionId}
            goToNextStep={goToNextStep}
          />
        ))
        .with(StateStep.Validated, () => (
          <ValidatedContent isComingSoon={isComingSoon} />
        ))
        .run()}
    </WebsiteModal>
  );
};
